module.exports = __webpack_public_path__ + "img/859587.d6f5341b.jpg";